import { ref } from 'vue';
import { base as baseTheme } from '../../theme-builder/themes/base';
import type { HasTheme, Theme } from '../../theme-builder';
import { datadogRum } from '@datadog/browser-rum';
import { captureException } from '@sentry/vue';

export type AppMode = 'native' | 'preview';

export const apps: App[] = [];

export class App implements HasTheme {
  public name: string;
  public mode: AppMode;
  public theme = ref<Theme>();

  constructor({ name, mode = 'native' }: { name: string; mode?: AppMode }) {
    const existingApp = apps.find((a) => a.name === name);

    if (existingApp) {
      Object.assign(this, existingApp);
    }

    this.name = name;
    this.mode = mode;
    this.theme.value = baseTheme;

    if (!existingApp) {
      apps.push(this);
    }
  }

  static get(name: string): App {
    let app = apps.find((a) => a.name === name);

    if (!app) {
      app = new App({ name });
    }

    return app;
  }

  setMode(mode: AppMode) {
    if (mode) {
      this.mode = mode;
    }

    return this;
  }

  setTheme(theme: Theme) {
    try {
      datadogRum.setUserProperty('theme', theme?.name || 'unknown');
    } catch (error) {
      captureException(error);
    }

    if (theme) {
      this.theme.value = theme;
    }

    return this;
  }
}
